import React from "react";
import { Modal, ModalBody } from "reactstrap";

function ConfirmSuccess(props) {
  const { show = false, label = "Saving..." } = props;

  return (
    <Modal isOpen={show} className="modal-success">
      <ModalBody>
        <h3 className="text-center mb-4">{label}</h3>

        <div className="success-checkmark">
          <div className="check-icon">
            <span className="icon-line line-tip"></span>
            <span className="icon-line line-long"></span>
            <div className="icon-circle"></div>
            <div className="icon-fix"></div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ConfirmSuccess;
